import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BaseModalWindow } from "./BaseModalWindow";
import { SupplierDataCheckAction } from "../../libs/coreapi-dto/dirs/supplierDataCheck";
import { IErrorItem } from "../alert/alertHelpers";
import styles from './styles/AlertsModal.module.scss'

interface IAlertsModalProps {
    items: IErrorItem[];
    header: string;
    question?: string;
    warning?: string;
    onFocusItem: (idGlobal: string) => void;
    onConfirm?: () => void;
    onCancel: () => void;
    action: SupplierDataCheckAction;
    textAreaInputStyle?: React.CSSProperties;
}

const AlertsModal: FC<IAlertsModalProps> = (props) => {
    const { t } = useTranslation();

    const handleCancel = () => {
        props.onCancel();
    };

    const handleConfirm = () => {
        props.onConfirm?.();
    };

    const isWarn = props.action === "WARN";
    const isLock = props.action === "LOCK";

    const modalStyle = isWarn
        ? { backgroundColor: "rgb(255, 204, 51, 0.2)", color: "#333333", padding: 15 }
        : { backgroundColor: "rgb(204, 51, 51, 0.2)", color: "#333333", padding: 15 };

    return (
        <BaseModalWindow
            header={props.header}
            ok={{
                onClick: handleConfirm,
                title: props.question ? t("general.accept") : t("general.ok"),
                hidden: !props.onConfirm
            }}
            cancel={{
                onClick: handleCancel,
                title: isLock ? t("general.ok") : t("general.cancel")
            }}
        >
            {props.warning && (
                <label style={{ whiteSpace: 'pre-line' }}>
                    {props.warning}
                </label>
            )}
            <div style={props.textAreaInputStyle || modalStyle} className={styles.alertsContainer}>
                {props.items.map(item => (
                    <div
                        key={item.idGlobal}
                    >
                        <a
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                props.onFocusItem?.(item.idGlobal);
                                props.onCancel();
                            }}
                        >
                            {item.goodsName}
                        </a>

                        <ul>
                            {item.alerts.map((alert, i) => (
                                <li key={i}>{alert.message}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            {props.question && (
                <>
                    <br />
                    <b>{props.question}</b>
                </>
            )}
        </BaseModalWindow>
    );
};

export default AlertsModal